import { createLocalStorageKeyStore } from "utils/create-local-storage-key-store"

export const empresaActivaStore = createLocalStorageKeyStore("empresaActiva")
